import { render, staticRenderFns } from "./ServiceCommon.vue?vue&type=template&id=3ed0f340&"
import script from "./ServiceCommon.vue?vue&type=script&lang=js&"
export * from "./ServiceCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports